module.exports = __webpack_public_path__ + "img/agd.bc10d9e0.svg";